import styled from 'styled-components';
import { colors } from 'bench-style-constants';

const EmptyTableRow = styled.div`
  background-color: ${colors.sand};
  box-shadow: 0 -1px 0 ${colors.silt};
  margin: 0 32px;
  min-height: 41px;
  padding: 8px;
  position: relative;
  opacity: ${({ isOver }) => (isOver ? 1 : 0)};
`;

export default EmptyTableRow;
